<template>
  <v-card tile>
    <v-card-title class="font-weight-black mt-5 text-uppercase">
      Welcome!
    </v-card-title>

    <v-divider role="presentation" class="mb-8"></v-divider>

    <v-text class="mt-5 mb-5">
      <p class="text-justify ml-4 body-1">
        Feel free to learn a bit about me by checking out my resume and
        projects, or you can contact me.
      </p>
    </v-text>

    <v-flex class="d-flex justify-start mt-8">
      <v-btn icon href="https://github.com/rizingson" target="_blank">
        <v-icon class="pa-2">mdi-github</v-icon>
      </v-btn>

      <v-btn
        icon
        href="https://www.facebook.com/damon.bonner.33"
        target="_blank"
      >
        <v-icon class="pa-2">mdi-facebook</v-icon>
      </v-btn>

      <v-btn
        icon
        href="https://www.instagram.com/rizing_son/?hl=en"
        target="_blank"
      >
        <v-icon class="pa-2">mdi-instagram</v-icon>
      </v-btn>

      <v-btn
        icon
        href="https://www.linkedin.com/in/damon-bonner-9a5579178/"
        target="_blank"
      >
        <v-icon class="pa-2">mdi-linkedin</v-icon>
      </v-btn>

      <v-btn icon href="mailto: damonjbonner@gmail.com">
        <v-icon class="pa-2">mdi-email</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: "Contact"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
